import { makeStyles } from "@material-ui/core/styles";

const styles = makeStyles(theme => ({
  contenedorTab: {
    borderRadius: "10px !important",
    marginBottom: 10,
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    "&::before": {
      display: "none"
    }
  },
  titleTab: {
    backgroundColor: "white",
    borderRadius: 10,
    fontSize: 20,
    fontWeight: "bold",
    color: "#333333",
    height: "60px",
    "& .MuiAccordionSummary-expandIcon.Mui-expanded": {
      color: "#0073cf"
    },
    [theme.breakpoints.down("xs")]: {
      paddingTop: "10px",
      paddingBottom: "5px",
      fontSize: 18
    }
  },
  descriptionTab: {
    fontSize: 16,
    color: "#333333",
    fontWeight: 300,
    lineHeight: "1.25em"
  },
  detailTab: {
    backgroundColor: "#e7f4ff",
    borderBottomLeftRadius: 10,
    borderBottomRightRadius: 10,
    padding: 20
  }
}));

export default styles;
